module.exports = __webpack_public_path__ + "static/img/fwfw_bagl.c3ed11b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fwfw_bagl.png
// module id = IZ4S
// module chunks = 1